var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7778 12.0194C26.7778 9.53893 25.7476 7.16004 23.9139 5.40608C22.0802 3.65211 19.5932 2.66675 17 2.66675C14.4068 2.66675 11.9198 3.65211 10.0861 5.40608C8.25238 7.16004 7.22222 9.53893 7.22222 12.0194C7.22222 20.3555 3.59053 24.1426 1.87622 25.4659C1.66748 25.627 1.79337 26.0484 2.05706 26.0484H11.0962C11.2132 26.0484 11.3151 26.1288 11.3482 26.2409C11.6064 27.1149 12.9075 30.6667 17 30.6667C21.0925 30.6667 22.3936 27.1149 22.6518 26.2409C22.6849 26.1288 22.7868 26.0484 22.9038 26.0484H31.9429C32.2066 26.0484 32.3325 25.627 32.1238 25.4659C30.4095 24.1426 26.7778 20.3555 26.7778 12.0194Z",
    stroke: "#7AC142",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0de54dbef654b8318d904b71a755323f.svg";
export { ForwardRef as ReactComponent };